export default class RegisterController {
    constructor(AuthService, $state, RegisterService, LoginService, $validation, $auth, 
    ProfilePermissionsService, $window, ContentService, $translate) {
        this.authService = AuthService;
        this.state = $state;
        this.service = RegisterService;
        this.loginService = LoginService;
        this.$auth = $auth;
        this.permissionsService = ProfilePermissionsService;
        this.contentService = ContentService;
        this.$window = $window;
        this.trans = $translate.instant;
        const _ = this.trans;
        $validation
            .setExpression({
                available: (value, scope, element, attrs) => {
                    return this.service.isEmailAvailability(value).toPromise().then(
                        (available) => {
                            this.validForm = available;
                            return available;
                        }, (available) => available
                    );
                }
            })
            .setDefaultMsg({
                available: {
                    error: _("Este dirección de correo no está disponible")
                }
            });
    }

    $onInit() {
        this.subscriptions = [];

        this.user = {};
        this.validForm = false;
    }
    $onDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
    
    register() {
        if (this.validForm) {
            this.subscriptions.push(
                this.service.register(this.user.name, this.user.email, this.user.password).subscribe(
                    (data) => {
                        if (!this.authService.isAuthenticated()) {
                            this.state.go('login');
                        }
                        this.verifyProfile();
                    },
                    (err) => console.log(err)
                )
            );
        }
    }

    verifyProfile() {
        this.subscriptions.push(
            this.loginService.getUserProfiles().subscribe((profiles) => {
                this.subscriptions.push(
                    this.contentService.getUserInvitations().subscribe(
                        (invitations) => {
                            if(invitations.length > 0){
                                this.state.go('pendingInvitations', {invitations: invitations, profiles: profiles});
                            } else if (profiles.length > 0) {
                                this.permissionsService.setProfilesCount(profiles.length);
                                this.state.go('profileSelection', {profiles: profiles});
                            } else {
                                this.state.go('accountRegistration');
                            }
                        }
                    )
                );
            })
        );
    }

    authenticateOauth(provider) {
        if (provider !== 'google') return;

        this.$window.localStorage.removeItem('google_state');
        this.$auth.authenticate(provider)
            .then(() => {
                this.verifyProfile();
            })
            .catch((error) => {
                if (error.message) {
                    this.notify.error(error.message);
                } else if (error.data) {
                    this.notify.error(error.data.message, error.status);
                } else {
                    this.notify.error(error);
                }
            });
    }
}


RegisterController.$inject = ['AuthService', '$state', 'RegisterService', 'LoginService', '$validation', '$auth', 
    'ProfilePermissionsService', '$window', 'ContentService', '$translate'];


// WEBPACK FOOTER //
// ./src/app/pages/register/register.controller.js